import {
  Pipe,
  PipeTransform,
  inject,
  ChangeDetectorRef,
  OnDestroy,
  isSignal,
} from '@angular/core';

import { AbstractSurveyService } from '@hyper-inferno/survey-bot-core';
import { BOT_SERVICE_TOKEN, UnifiedSurveyStore } from '../render-store/unified-survey.store';

@Pipe({
  name: 'Media',
  standalone: true,
  pure: false,
})
export class MediaPipe implements PipeTransform, OnDestroy {
  private surveyBot = inject(BOT_SERVICE_TOKEN)

  private cdr = inject(ChangeDetectorRef);

  private lastPath: string | null = null;
  private lastSurveyId: number | undefined = undefined;
  private currentResolvedUrl = '';

  private surveyStore = inject(UnifiedSurveyStore)

  transform(rawPath: any): string {
    const mediaPath = isSignal(rawPath) ? rawPath() : rawPath;
    if (!mediaPath) {
      return '';
    }

    // Already a usable browser URL
    if (
      typeof mediaPath === 'string' &&
      (
        mediaPath.startsWith('blob:') ||
        mediaPath.startsWith('data:')
      )
    ) {
      return mediaPath;
    }

    const botInstance = this.surveyBot;

    const surveyId = Number(this.surveyStore.context())
    // typeof botInstance?.getCurrentSurveyId === 'function'
    //   ? botInstance.getCurrentSurveyId()
    //   : undefined;

    if (!surveyId) {
      return mediaPath;
    }

    // Cache hit
    if (
      this.lastPath === mediaPath &&
      this.lastSurveyId === surveyId
    ) {
      return this.currentResolvedUrl || mediaPath;
    }

    // New media
    this.lastPath = mediaPath;
    this.lastSurveyId = surveyId;
    this.currentResolvedUrl = '';
    if (
      typeof botInstance.getAttachmentUrl === 'function'
    ) {
      botInstance
        .getAttachmentUrl(surveyId, mediaPath)
        .then((blobUrl: string | null) => {
          if (blobUrl) {
            this.currentResolvedUrl = blobUrl;
          } else {
            this.currentResolvedUrl = mediaPath;
          }

          this.cdr.markForCheck();
        })
        .catch((err: any) => {
          console.error('[MediaPipe Error]', err);

          this.currentResolvedUrl = mediaPath;
          this.cdr.markForCheck();
        });
    } else {
      this.currentResolvedUrl = mediaPath;
    }

    return this.currentResolvedUrl || mediaPath;
  }

  ngOnDestroy(): void {
    if (
      this.currentResolvedUrl &&
      this.currentResolvedUrl.startsWith('blob:')
    ) {
      const botInstance = this.surveyBot as any;

      if (
        typeof botInstance?.revokeAttachmentUrl === 'function'
      ) {
        botInstance.revokeAttachmentUrl(this.currentResolvedUrl);
      }
    }
  }
}